import React, { createContext, useContext, useState, useCallback } from "react";
import { DICT } from "@/lib/i18n_dict";

const I18nContext = createContext(null);

export const LANGS = [
  { code: "ja", label: "日本語" },
  { code: "en", label: "English" },
  { code: "pt", label: "Português" },
];

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("neo_lang") || "ja");

  const setLang = useCallback((l) => {
    localStorage.setItem("neo_lang", l);
    setLangState(l);
  }, []);

  const t = useCallback((s) => {
    if (s == null) return s;
    if (lang === "ja") return s;
    const entry = DICT[s];
    return (entry && entry[lang]) || s;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) return { lang: "ja", setLang: () => {}, t: (s) => s };
  return ctx;
}
